<template>

   

    <div v-if="this.$parent.is_processing_get_contact && this.$parent.is_processing_get_contact === true" style="margin:0 auto;">
        <p>Loading contact data...</p>
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="L4" x="0px" y="0px" enable-background="new 0 0 0 0" xml:space="preserve" viewBox="0 44 52 12" style="max-width: 100px;width:100%;margin:0 auto;text-align:center;">
            <circle fill="var(--blue)" stroke="none" cx="6" cy="50" r="6">
                <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.1"/>    
            </circle>
            <circle fill="var(--blue)" stroke="none" cx="26" cy="50" r="6">
                <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.2"/>       
            </circle>
            <circle fill="var(--blue)" stroke="none" cx="46" cy="50" r="6">
                <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.3"/>     
            </circle>
        </svg>
    </div>
    <div v-else-if="!this.$parent.contact_data  ">
        <p>No contact found.</p>
    </div>
    <div v-else class="content pl-4 pr-4">
       
        <!-- this.$parent.contact_data && this.$parent.contact_data.contact_lists_data && this.$parent.contact_data.contact_lists_data.sent_to && this.$parent.contact_data.contact_lists_data.sent_to !== null -->
        <div class="this_contact_contain">
            <div class="contact_heading mt-4" v-if="this.$parent.this_vue_data_front_context && this.$parent.this_vue_data_front_context.conversation && this.$parent.this_vue_data_front_context.conversation.recipient && this.$parent.this_vue_data_front_context.conversation.recipient.contact">
                <h1 v-if="this.$parent.this_vue_data_front_context.conversation.recipient.contact.name">{{this.$parent.this_vue_data_front_context.conversation.recipient.contact.name}}</h1>
                <span v-if="this.$parent.this_front_conversation_sent_to_number !== null" class="material-icons material-icons-outlined call_button_inline bubble_green" v-on:click="call_this_contact(this.$parent.this_front_conversation_sent_to_number)" >phone_forwarded</span>
            </div>
            <div style="clear:both;"></div>
            <div class="contact_nav_tab_contain mb-3">
                <b-tabs v-model="active_contact_tab_index" align="left" no-fade>
                    <b-tab active title="Overview" v-on:click="set_active_tab_pane('overview')">

                    </b-tab>
                   <!-- <b-tab title="Contact"></b-tab>
                    <b-tab title="Messages"></b-tab>
                    <b-tab title="Survey Questions" v-on:click="set_active_tab_pane('survey_questions')"></b-tab>
                    <b-tab title="Activist Codes" disabled></b-tab>
                    <b-tab title="Donations"> </b-tab>
                    <b-tab title="Lists"></b-tab> -->
                </b-tabs>
                
            </div>

            <div v-if="this.active_tab_pane_name === 'overview'">

                
                <div v-if="this.$parent.is_processing_get_contact && this.$parent.is_processing_get_contact === true" class="loading">
                    <p>Loading contact data...</p>
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="L4" x="0px" y="0px" enable-background="new 0 0 0 0" xml:space="preserve" viewBox="0 44 52 12">
                        <circle fill="var(--blue)" stroke="none" cx="6" cy="50" r="6">
                            <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.1"/>    
                        </circle>
                        <circle fill="var(--blue)" stroke="none" cx="26" cy="50" r="6">
                            <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.2"/>       
                        </circle>
                        <circle fill="var(--blue)" stroke="none" cx="46" cy="50" r="6">
                            <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.3"/>     
                        </circle>
                    </svg>
                </div>
                <!-- 220329 v-if="this.$parent.contact_data && this.$parent.contact_data.incoming_messages && this.$parent.contact_data.incoming_messages.length && this.$parent.contact_data.incoming_messages.length > 0" -->
                <div v-else>
                    <!--220329 v-if="this.$parent.this_conversation_contact_last_incoming_message || this.$parent.this_conversation_contact_last_sent_campaign_message" -->
                    <b-container>
                       
                        <div v-if="this.$parent.contact_data && this.$parent.contact_data.merged_messages && this.$parent.contact_data.merged_messages.length && this.$parent.contact_data.merged_messages.length > 0" class="messages_top_white" id="messages_container_scroll_loading">
                            
                            <h2>Conversation Action</h2>
                            
                            <div class="script_preview_contain_top" id="messages_container_scroll">
                                <b-row v-for="(this_message,index) in this.$parent.contact_data.merged_messages" :key="this_message.message_uuid" >
                                
                                    <div class="mine messages" v-if="this_message.body && this_message.direction === 'outbound' ">
                                        <div class="message">{{this_message.body}}</div>

                                        <div v-if="this_message.script_name" class="script_message_button">
                                            <base-button size="sm" v-on:click="set_active_conversation_script(null,this_message.script_uuid)" ><span class="material-icons material-icons-outlined md-18 icon_blue">description</span> {{this_message.script_name}}</base-button>
                                        </div>
                                        
                                    </div>
                                    
                                    <div class="yours messages" v-else-if="(this_message.body || this_message.media_url) && this_message.direction === 'incoming'">
                                        <div class="message_image" v-if="this_message.media_url">
                                            <img :src="this_message.media_url">
                                        </div>
                                        <div class="message" v-if="this_message.body">
                                            {{this_message.body}}
                                        </div>

                                        <div>
                                            <div v-if="(this_message && this_message.opt_out_type && this_message.opt_out_type !== null ) ">
                                                <!--|| ( this.$parent && this.$parent.contact_data && this.$parent.contact_data.contact_lists_data && this.$parent.contact_data.contact_lists_data.is_sms_optout && this.$parent.contact_data.contact_lists_data.is_sms_optout === true)-->
                                                <b-badge variant="success" v-if="this_message.opt_out_type === 'START'">Subscribed</b-badge>
                                                <b-badge variant="danger" v-else-if="this_message.opt_out_type === 'STOP'">Unsubscribed</b-badge>
                                            </div>
                                            <div v-else>
                                                <div v-bind:id="chicklet_parent(index)">
                                                    <b-badge variant="warning" class="click_cursor" v-bind:id="chicklet_child_to_remove(index)" v-on:click="unsub_this_contact(index)">Unsubscribe This Contact</b-badge>                
                                                </div>
                                            </div>
                                        </div>
                                        
                                        
                                    </div>



                                </b-row>
                                <div class="quick_replies_contain" v-if="this.$parent.available_quick_replies && this.$parent.available_quick_replies.length > 0">
                                    <p><i>Quick Replies:</i></p>
                                    <ul>
                                        <li v-for="(quick_reply) in this.$parent.available_quick_replies" :key="quick_reply.quick_reply_uuid" v-on:click="generate_quick_draft_reply(quick_reply.quick_reply_uuid)" class="quick_reply_button">
                                            {{quick_reply.text_short_name}}
                                        </li>
                                    </ul>
                                </div>
                                <div class="quick_survey_question_contain" v-if="survey_question_reply_open === true" >

                                    <div v-if="this.is_saving_survey_question_data === false" class="blue_border_top">
                                        <p class="sc_top_info">Save Survey Question Data:</p>

                                        <form>
                                                                
                                            <div class="answer_input_contain">
                                            
                                                <div v-if="active_survey_question.input_type === 'text'">
                                                    <base-input
                                                        :placeholder="active_survey_question.survey_question_placeholder"
                                                        :name="active_survey_question.survey_question_uuid"
                                                        :id="active_survey_question.survey_question_uuid"
                                                        :required="active_survey_question.input_required"
                                                        class="full-width" 
                                                        v-model="draft_survey_question_answer_value"
                                                        
                                                    />
                                                </div>


                                                <div v-if="active_survey_question.input_type === 'textarea'">
                                                    <b-form-textarea
                                                        :placeholder="active_survey_question.survey_question_placeholder"
                                                        :name="active_survey_question.survey_question_uuid"
                                                        :id="active_survey_question.survey_question_uuid"
                                                        :required="active_survey_question.input_required"
                                                        class="full-width" 
                                                        :rows="active_survey_question.input_rows"
                                                        :max-rows="active_survey_question.input_max_rows"
                                                        v-model="draft_survey_question_answer_value"
                                                    
                                                    >
                                                    </b-form-textarea>
                                                </div>

                                                <div v-else-if="active_survey_question.input_type === 'checkbox'" class="survey_question_checkbox_contain">

                                                    <b-form-checkbox
                                                        class="full-width"
                                                        :placeholder="active_survey_question.survey_question_placeholder"
                                                        :name="active_survey_question.survey_question_uuid"
                                                        :id="active_survey_question.survey_question_uuid"
                                                        :checked="active_survey_question.input_checked_default"
                                                        :required="active_survey_question.input_required"
                                                        :unchecked-value="active_survey_question.input_xunchecked_value"
                                                        v-model="draft_survey_question_answer_value"
                                                    
                                                    >
                                                        <h3>{{active_survey_question.survey_question_placeholder}}</h3>
                                                    </b-form-checkbox>
                                                
                                                </div>

                                                <div v-else-if="active_survey_question.input_type === 'dropdown'" class="survey_question_dropdown_contain">
                                                
                                                        <b-dropdown variant="default" class="" id="inactive_sc_btn_2">
                                                            <template v-slot:button-content>
                                                                <span v-if="active_survey_question.input_icon_string" class="material-icons material-icons-outlined">{{active_survey_question.input_icon_string}}</span> {{active_survey_question.survey_question_placeholder}}
                                                            </template>
                                                            <b-dropdown-item v-for="(value) in active_survey_question.input_values"
                                                            :key="value.input_values"
                                                            :disabled="is_saving_survey_question_data"
                                                            v-on:click="send_survey_question_data(active_survey_question.survey_question_uuid,value)">
                                                                {{value}}
                                                            </b-dropdown-item>
                                                        </b-dropdown>

                                                        <base-button icon type="light" v-on:click="close_survey_question_ui()">
                                                            <span class="btn-inner--icon material-icons material-icons-outlined md-18">close</span>
                                                        </base-button>
                                                
                                                </div>

                                                <div v-else-if="active_survey_question.input_type === 'multi_select'" class="survey_question_dropdown_contain">
                                                    <base-input :label="active_survey_question.survey_question_placeholder">
                                                        <el-select v-model="draft_survey_question_answer_value"
                                                                    multiple
                                                                    filterable
                                                                    placeholder="Multiple select">
                                                            <el-option v-for="(value) in active_survey_question.input_values"
                                                                    :key="value.input_values"
                                                                    :label="value.input_values"
                                                                    :value="value.input_values">
                                                            </el-option>
                                                        </el-select>
                                                    </base-input>
                                                   
                                               
                                                    <base-button icon type="success" v-on:click="send_survey_question_data(active_survey_question.survey_question_uuid,draft_survey_question_answer_value)" :disabled="is_saving_survey_question_data">
                                                        <span class="btn-inner--icon material-icons material-icons-outlined md-18">close</span>
                                                    </base-button>
                                                    <base-button icon type="light" v-on:click="close_survey_question_ui()">
                                                        <span class="btn-inner--icon material-icons material-icons-outlined md-18">close</span>
                                                    </base-button>
                                                
                                                </div>

                                                <div v-else-if="active_survey_question.input_type === 'range'" class="survey_question_range_contain">
                                

                                                    <div class="range_label_contain">
                                                        <div class="range_label_left">
                                                            <p>Strong {{active_survey_question.input_min_name}}</p>
                                                        </div>
                                                        
                                                        <div class="range_label_right">
                                                            <p>Strong {{active_survey_question.input_max_name}}</p>
                                                        </div>
                                                        <div style="clear:both;"></div>
                                                    </div>
                                                    <div class="styled_range_input_contain">
                                                        <input type="range"
                                                        v-model=draft_survey_question_answer_value
                                                        :min=active_survey_question.input_min
                                                        :max=active_survey_question.input_max steps="1"

                                                        class="gradient-range" >
                                                    </div>
                                                    <div style="clear:both;"></div>
                                                    <div class="range_label_center">
                                                        <p>{{draft_survey_question_answer_value}}</p>
                                                    </div>
                                                </div>
                                
                                            </div>

                                            <div class="save_sc_inline_contain">
                                                <div class="inline_sc_buttons" v-if="active_survey_question.input_type !== 'dropdown'">

                                                    <base-button icon type="primary" 
                                                        v-on:click="send_survey_question_data()" 
                                                        :disabled="is_saving_survey_question_data"
                                                        >
                                                        <span class="btn-inner--icon material-icons material-icons-outlined md-18">assignment_turned_in</span>
                                                        <span class="btn-inner--text">Save Data</span>
                                                    </base-button>
                                    
                                                    <base-button icon type="light" v-on:click="close_survey_question_ui()">
                                                        <span class="btn-inner--icon material-icons material-icons-outlined md-18">close</span>
                                                    </base-button>
                            
                                                </div>
                                            </div>
                                            
                                        </form>
                                    </div>
                                    <div v-else-if="this.is_saving_survey_question_data === true" class="sending_message_dots_centered">
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="L4" x="0px" y="0px" enable-background="new 0 0 0 0" xml:space="preserve" viewBox="0 44 52 12">
                                            <circle fill="var(--blue)" stroke="none" cx="6" cy="50" r="6">
                                                <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.1"/>    
                                            </circle>
                                            <circle fill="var(--blue)" stroke="none" cx="26" cy="50" r="6">
                                                <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.2"/>       
                                            </circle>
                                            <circle fill="var(--blue)" stroke="none" cx="46" cy="50" r="6">
                                                <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.3"/>     
                                            </circle>
                                        </svg>
                                    </div>



                                    

                                </div>
                            </div>
                            <div class="script_preview_contain_bottom">
                                <b-container class="bv-example-row">
                                    <div class="reply_contain_flex">
                                        <div class="reply_box_left">
                                           

                                            <b-dropdown id="inline_survey_question_dropup" dropup text="+ Data" variant="primary" class="">
                                                <b-dropdown-item v-for="(survey_question) in this.available_survey_questions" :key="survey_question.survey_question_uuid" v-on:click="pop_survey_question_ui(survey_question.survey_question_uuid)">
                                                    {{survey_question.survey_question_name}}
                                                </b-dropdown-item>
                                            </b-dropdown>
                                          
                                        </div>
                                        <div class="reply_box_middle">
                                            <base-input>
                                                <textarea class="form-control" id="inline_draft_reply" 
                                                v-model="draft_reply" rows="1" 
                                                :placeholder="draft_reply"
                                                
                                                ></textarea>
                                                <div class="send_area_emoji_icon send_area_icon">
                                                    <span class="material-icons material-icons-outlined icon_blue">insert_emoticon</span>
                                                </div>
                                            </base-input>
                                        </div>
                                        <div class="reply_box_right">
                                            <div class="send_area_control_contain send_area_icon" v-if="is_sending_message === false">
                                                <span class="material-icons material-icons-outlined icon_blue" v-if="draft_reply === null || draft_reply === ''">image</span>
                                                <span class="material-icons material-icons-outlined icon_blue" v-else-if="draft_reply !== null" v-on:click="send_this_message()">send</span>
                                            </div>
                                            <div v-else class="send_area_control_contain send_area_icon typing_svg">
                                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="L4" x="0px" y="0px" enable-background="new 0 0 0 0" xml:space="preserve" viewBox="0 44 52 12">
                                                    <circle fill="var(--blue)" stroke="none" cx="6" cy="50" r="6">
                                                        <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.1"/>    
                                                    </circle>
                                                    <circle fill="var(--blue)" stroke="none" cx="26" cy="50" r="6">
                                                        <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.2"/>       
                                                    </circle>
                                                    <circle fill="var(--blue)" stroke="none" cx="46" cy="50" r="6">
                                                        <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.3"/>     
                                                    </circle>
                                                </svg>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </b-container>
                            </div>
                        </div>
                        


                    </b-container>

                    <b-container class="container-fluid">

                        <div>
                            <div v-if="this.$parent.contact_data && this.$parent.contact_data.contact_lists_data" class="summary_item_contain container-fluid">
                                <h2>Contact Data</h2>
                                <b-row>
                                    <b-col class="summery_item_col">
                                        <p>Name</p>
                                        <h4>
                                            <span v-if="this.$parent.contact_data.contact_lists_data.first_name">
                                                {{this.$parent.contact_data.contact_lists_data.first_name}} 
                                            </span>
                                            <span v-if="this.$parent.contact_data.contact_lists_data.last_name">
                                                {{this.$parent.contact_data.contact_lists_data.last_name}} 
                                            </span>
                                        </h4>
                                    </b-col>
                                    <b-col class="summery_item_col">
                                        <p>Location</p>
                                        <h4>
                                            <span v-if="this.$parent.contact_data.contact_lists_data.city">
                                                {{this.$parent.contact_data.contact_lists_data.city}}, 
                                            </span>
                                            <span v-if="this.$parent.contact_data.contact_lists_data.state">
                                                {{this.$parent.contact_data.contact_lists_data.state}}, 
                                            </span>
                                            <span v-if="this.$parent.contact_data.contact_lists_data.zip">
                                                {{this.$parent.contact_data.contact_lists_data.zip}}
                                            </span>
                                        </h4>
                                    </b-col>
                                    <b-col class="summery_item_col">
                                        <p>Contact</p>
                                        <h4 v-if="this.$parent.contact_data.contact_lists_data.sent_to"  class="mini_text_small_screen">
                                            <span class="material-icons material-icons-outlined md-18 icon_blue">phone_iphone</span> {{this.$parent.contact_data.contact_lists_data.sent_to}}
                                        </h4>
                                        <h4 v-if="this.$parent.contact_data.contact_lists_data.email" class="mini_text_small_screen">
                                            <span class="material-icons material-icons-outlined md-18 icon_blue">email</span> {{this.$parent.contact_data.contact_lists_data.email}}
                                        </h4>
                                    </b-col>
                                    <b-col class="summery_item_col" v-if="
                                        
                                        this.$parent.contact_data.contact_lists_data.is_sms_optout === true ||
                                        this.$parent.contact_data.contact_lists_data.do_not_call === true ||
                                        this.$parent.contact_data.contact_lists_data.twilio_verified_cell === false ||
                                        this.$parent.contact_data.contact_lists_data.twilio_carrier_type === 'landline' ||
                                        this.$parent.contact_data.contact_lists_data.twilio_carrier_type === 'voip' 
                                    ">
                                        <p>Opt Out</p>
                                        <b-row>
                                        
                                            <b-col v-if="this.$parent.contact_data.contact_lists_data.is_sms_optout">
                                                <b-badge variant="danger">SMS</b-badge>
                                            </b-col>
                                            <b-col v-if="this.$parent.contact_data.contact_lists_data.do_not_call">
                                                <b-badge variant="danger">DNC</b-badge>
                                            </b-col>
                                            <b-col v-if="this.$parent.contact_data.contact_lists_data.twilio_verified_cell === false">
                                                <b-badge variant="danger">Bad Phone</b-badge>
                                            </b-col>
                                            <b-col v-if="this.$parent.contact_data.contact_lists_data.twilio_carrier_type === 'landline'">
                                                <b-badge variant="danger">Land Line</b-badge>
                                            </b-col>
                                            <b-col v-if="this.$parent.contact_data.contact_lists_data.twilio_carrier_type === 'voip'">
                                                <b-badge variant="warning">VOIP</b-badge>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                        
                        <div>
                            <div v-if="this.has_json_contact_data === true" class="summary_item_contain container-fluid ">
                                <h2>Custom Contact Data</h2>
            
                                <p>{{this.this_contact_json_contact_data}}</p>
                            </div>
                        </div>
                        
                    
                        <div>
                            <div v-if="this.this_contact_survey_question_answers" class="summary_item_contain container-fluid ">
                                <h2>Survey Question Responses</h2>
                                <div v-if="this.this_contact_survey_question_answers && this.this_contact_survey_question_answers.length && this.this_contact_survey_question_answers.length > 0" class="sc_group_list">
                                    
                                        <div v-for="(survey_question_answer) in this.this_contact_survey_question_answers" :key="survey_question_answer.survey_question_answer_uuid" class="sc_item">
                                            <b-row>
                                                <b-col >
                                                    <h3>{{survey_question_answer.survey_question_name}}</h3>
                                                </b-col>
                                                <b-col >
                                                    <p class="sc_script_name"><span class="material-icons material-icons-outlined md-18 icon_blue">description</span> <i>{{survey_question_answer.script_name}}</i></p>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col>
                                                    <div v-if="survey_question_answer.survey_question_data_type === 'string'">
                                                        <p v-if="survey_question_answer.survey_question_answer_value === 'true' || survey_question_answer.survey_question_answer_value ==='TRUE'">
                                                            <b-badge variant="success">Yes</b-badge>
                                                        </p>
                                                        <p v-else-if="survey_question_answer.survey_question_answer_value === 'false' || survey_question_answer.survey_question_answer_value ==='FALSE'">
                                                            <b-badge variant="warning">No</b-badge>
                                                        </p>
                                                        <p v-else>{{survey_question_answer.survey_question_answer_value}}</p>
                                                    </div>
                                                    <div v-if="survey_question_answer.survey_question_data_type === 'bool'">
                                                        <b-badge v-if="survey_question_answer.survey_question_answer_value === 'true' || survey_question_answer.survey_question_answer_value ==='TRUE'" variant="primary">{{survey_question_answer.survey_question_answer_value}}</b-badge>
                                                        <b-badge v-if="survey_question_answer.survey_question_answer_value === 'false' || survey_question_answer.survey_question_answer_value ==='FALSE'" variant="danger">{{survey_question_answer.survey_question_answer_value}}</b-badge>
                                                    </div>
                                                    <div v-if="survey_question_answer.survey_question_data_type === 'int64' || survey_question_answer.survey_question_data_type === 'float64'">
                                                        <p>{{survey_question_answer.survey_question_answer_value}}</p>
                                                    </div>
                                                    <div v-if="survey_question_answer.survey_question_data_type === 'array'">
                                                        <p v-for="(survey_question_answer_array_value) in survey_question_answer.survey_question_answer_value" :key="survey_question_answer.survey_question_answer_value" >
                                                        {{survey_question_answer_array_value}}
                                                        </p>
                                                    </div>
                                                </b-col>
                                            </b-row>
                                                
                                                

                                        </div>
                                    
                                </div>
                            </div>
                        </div>

                        <div>
                            <div v-if="this.$parent.contact_data.actblue_sum" class="summary_item_contain container-fluid">
                                <h2>Donations</h2>
                                <b-row>
                                    <b-col class="summery_item_col">
                                        <p>Donations Total</p>
                                        <h3>
                                            <span v-if="this.$parent.contact_data.actblue_sum.sum_donations">
                                                {{this.$parent.contact_data.actblue_sum.sum_donations}}
                                            </span>
                                            <span v-else>0</span>
                                        </h3>
                                    </b-col>
                                    <b-col class="summery_item_col">
                                        <p>Number Donations</p>
                                        <h3>
                                            <span v-if="this.$parent.contact_data.actblue_sum.count_donations">
                                                {{this.$parent.contact_data.actblue_sum.count_donations}}
                                            </span>
                                            <span v-else>0</span>
                                        </h3>
                                    </b-col>
                                    <b-col class="summery_item_col">
                                        <p>Recurring Total</p>
                                        <h3>
                                            <span v-if="this.$parent.contact_data.actblue_sum.sum_recurring">
                                                    {{this.$parent.contact_data.actblue_sum.sum_recurring}}
                                            </span>
                                            <span v-else>0</span>
                                        </h3>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                    </b-container>
                </div>
            </div>

            <div v-else-if="this.active_tab_pane_name === 'survey_questions'">
                <div v-if="this.has_survey_questions === true" class="survey_questions_contain">

                        <b-card title="Survey Question Response" no-body>
                        <h3>Select This Conversation's Script</h3>
                                <b-nav card-header tabs type="light" class='ml-0'>
                                    <b-nav-item active v-b-tooltip.hover.right :title="this.this_active_script.script_text_fallback" >Current Script</b-nav-item>
                                    <b-nav-item-dropdown
                                    id="my-nav-dropdown"
                                    text="Older Scripts"
                                    toggle-class="nav-link-custom"
                                    right
                                    >

                                        <b-dropdown-item v-on:click="set_active_conversation_script(null,this_script.script_uuid)" 
                                        v-for="this_script in available_scripts" :key="this_script.script_uuid" 
                                        >{{this_script.script_name}}</b-dropdown-item><!-- todo get toot tip preview to work-->

                                    </b-nav-item-dropdown>
                                </b-nav>
            

                            <b-card-body class="survey_question_card_body_contain" v-if="this.this_active_script && this.this_active_script !== null">
                                <p class="preview_info_text">Script Preview</p>
                                <div class="script_preview_contain">
                                    
                                    <div class="second_pad_script_preview">
                                        <p><span class="material-icons material-icons-outlined md-18">campaign</span> </p>
                                        <p>{{this.this_active_script.script_name}}:</p>
                                        
                                        <div class="mine messages" v-if="this.this_active_script.script_text_fallback">
                                            <div class="message last">{{this.this_active_script.script_text_fallback}}</div>
                                        </div>
                                        <div class="yours messages" v-if="this.$parent.this_conversation_contact_last_incoming_message">
                                            <!-- TODO parse if only emoji lol then make it big -->
                                            <div class="message last">{{this.$parent.this_conversation_contact_last_incoming_message.body}}</div>
                                        </div>
                                    </div>
                                </div>




                
                                
                                <div role="tablist" class="accordion survey_questions_accordian"  v-if="this.available_survey_questions && this.available_survey_questions.length > 0">

                                    <h2 class="survey_questions_header mt-4"><span class="material-icons material-icons-outlined ">checklist</span> Save Survey Question Data</h2>

                                    <b-card no-body class="mb-1"  v-for="(survey_question,index) in available_survey_questions" :key="survey_question.survey_question_uuid"   >
                                        <b-card-header header-tag="header" href="#" role="tab" v-b-toggle="`${index}`">
                                            <h2 class="mb-0">{{survey_question.survey_question_name}}</h2>
                                        </b-card-header>

                                        <b-collapse  :id="`${index}`" accordion="my-accordion" role="tabpanel">
                                            <b-card-body>
                                               
                                                <div class="survey_question_form_contain">
                                                    
                                                    
                                                </div>



                                            </b-card-body>
                                        </b-collapse>
                                    </b-card>

                                </div>
                                
                            </b-card-body>
                        </b-card>


                </div>
            </div> <!--end active tab survey_questions -->
        </div>
      


        
    </div>
</template>

<script>
    
    import swal from 'sweetalert2';
    import { BModal,TabsPlugin, BSpinner, BBadge, BListGroup } from 'bootstrap-vue'
    import accordion from '@/components/Collapse/CollapseItem.vue'
    import { CollapseTransition } from 'vue2-transitions';
    import generate_send_message from '@/util/generate_send_message.js' //TODO move to helpers
    import helpers from '@/util/helpers.js'
    

    export default {
        components: { 
            swal,
            BModal,
            TabsPlugin,
            BSpinner,
            BListGroup,
            BBadge,
            accordian:accordion,
            CollapseTransition:CollapseTransition
        },
        data() {
            return {
                active_contact_tab_index: 0,
                active_tab_pane_name: 'overview',
                active_conversation_script: '',
                active_survey_question:{},

                draft_reply: null,
                draft_sms_attachment: null,
                is_sending_message: false,
                is_saving_survey_question_data: false,
                survey_question_response_from_quick_reply: false,
                is_send_textarea_focused: false,
              
                focused_survey_question_uuid: null,
                survey_question_reply_open: false,
                draft_survey_question_answer_value: null,
                this_active_script: {}
            }
        },
        computed: {

            has_json_contact_data: function() {
                try {
                    if(
                        typeof this.$parent.contact_data !== 'undefined' &&
                        typeof this.$parent.contact_data.contact_lists_data !== 'undefined' &&
                        typeof this.$parent.contact_data.contact_lists_data.json_contact_data !== 'undefined' &&
                        this.$parent.contact_data.contact_lists_data.json_contact_data !== null &&
                        this.$parent.contact_data.contact_lists_data.json_contact_data !== ''
                    ) {
                        console.log('debug has json contact data')
                            return true
                    }
                } catch(e) {
                    console.log(e)
                    return false
                }
            },
            this_contact_json_contact_data: function() {
                try {
                    if(
                        typeof this.$parent.contact_data !== 'undefined' &&
                        typeof this.$parent.contact_data.contact_lists_data !== 'undefined' &&
                        typeof this.$parent.contact_data.contact_lists_data.json_contact_data !== 'undefined' &&
                        this.$parent.contact_data.contact_lists_data.json_contact_data !== null &&
                        this.$parent.contact_data.contact_lists_data.json_contact_data !== ''
                    ) {
                        //parse base64
                        try {   
                            //check the uuids match?
                            if(this.$parent.active_contact.contact_uuid !== this.$parent.contact_data.contact_lists_data.contact_uuid) {
                                console.log('uuids dont align?')
                                console.log(this.$parent.active_contact.contact_uuid)
                                console.log(this.$parent.contact_data.contact_lists_data.contact_uuid)
                                return null
                            }

                            if (typeof this.$parent.contact_data.contact_lists_data.json_contact_data === 'string') {
                                console.log('debug parsed custom data')
                                console.log(JSON.parse(atob(this.$parent.contact_data.contact_lists_data.json_contact_data)))
                                return JSON.parse(atob(this.$parent.contact_data.contact_lists_data.json_contact_data))
                                
                            } else {
                                return null
                            }

                        } catch (e) {
                            console.log(e)
                            return null
                        }
                    } else {
                        return null
                    }
                } catch(e) {
                    console.log(e)
                    return null
                }
            },

            this_contact_survey_question_answers: function() {
                this.$nextTick(function () {
                    try {
                        if(typeof this.$parent.contact_data !== 'undefined' && typeof this.$parent.contact_data.survey_question_answers !== 'undefined' && this.$parent.contact_data.survey_question_answers && this.$parent.contact_data.survey_question_answers.length && this.$parent.contact_data.survey_question_answers.length > 0) {
                            
                            if(typeof this.$parent.survey_questions !== 'undefined' && this.$parent.survey_questions && this.$parent.survey_questions.length && this.$parent.survey_questions.length > 0) {
                                
                                let this_merged_answers = []

                                this.$parent.contact_data.survey_question_answers.forEach((contact_sc_answer,index) => {

                                    this.$parent.survey_questions.forEach((survey_question,index) => {
                                        if(survey_question.survey_question_uuid === contact_sc_answer.survey_question_uuid) {

                                            //god damned too many loops
                                            let matched_script = {}
                                            this.$parent.scripts.forEach((script,index) => {
                                                if(survey_question.script_uuid = script.script_uuid) {
                                                    matched_script = script
                                                }
                                            })
                                        this_merged_answers.push(Object.assign(contact_sc_answer, survey_question,matched_script))
                                        }
                                    })

                                });

                               // console.log('debug this_merged_answers')
                               // console.log(this_merged_answers)

                                return this_merged_answers
                                
                            } else {
                                return null
                            }
                        } else {
                            return null
                        }
                    } catch(e) {
                        console.log('error merging contact sc')
                        console.log(e)
                        return null
                    }
                })
                
            },
            has_survey_questions: function() {
                return true
            },
            itemId() {
                return this.id || this.title;
            },
            this_conversation_contact_last_incoming_message_uuid() {
                if(this.$parent.this_conversation_contact_last_incoming_message && this.$parent.this_conversation_contact_last_incoming_message.message_uuid) {
                    return this.$parent.this_conversation_contact_last_incoming_message.message_uuid
                } else {
                    return null
                }
            },
            this_conversation_contact_last_sent_campaign_message_uuid() {
                if(this.$parent.this_conversation_contact_last_sent_campaign_message && this.$parent.this_conversation_contact_last_sent_campaign_message.message_uuid) {
                    return this.$parent.this_conversation_contact_last_sent_campaign_message.message_uuid
                } else {
                    return null
                }
            },
            this_conversation_contact_last_sent_campaign_uuid(){
                if(this.$parent.this_conversation_contact_last_sent_campaign_message && this.$parent.this_conversation_contact_last_sent_campaign_message.outbound_campaign_uuid) {
                    return this.$parent.this_conversation_contact_last_sent_campaign_message.outbound_campaign_uuid
                } else {
                    return null
                }
            },
            available_scripts() {
               // console.log('debug available_Scripts')

                let array_of_script_uuids = []
                let array_of_script_data = []

                if(this.$parent.contact_data && this.$parent.contact_data.outbound_messages && this.$parent.contact_data.outbound_messages.length > 0) {
                    this.$parent.contact_data.outbound_messages.forEach(this_outbound_message => {

                      //  console.log(this_outbound_message.script_uuid)


                        if(!array_of_script_uuids.includes(this_outbound_message.script_uuid)) {
                            array_of_script_uuids.push(this_outbound_message.script_uuid)
                        
                            array_of_script_data.push(
                                {
                                    script_uuid: this_outbound_message.script_uuid,
                                    script_name: this_outbound_message.script_name || null,
                                    script_text_handlebars: this_outbound_message.script_text_handlebars || null,
                                    script_text_fallback: this_outbound_message.script_text_fallback || null
                                }
                            )
                        
                        }
                    })
                }

                return array_of_script_data
        
            },
            available_survey_questions: function() {
                let array_of_survey_questions = []
                let array_of_survey_question_uuids = []

                if(this.active_conversation_script && this.active_conversation_script !== null) {
                    //console.log('debug active_conversation_script ' + this.active_conversation_script )

                    this.$parent.survey_questions.forEach((survey_question,index) => {
                        //console.log('debug survey_question.script_uuid ' )

                        //change to array
                        if(survey_question.script_uuids.length && survey_question.script_uuids.length > 0) {
                            if(survey_question.script_uuids.includes(this.active_conversation_script)) {
                                if(!array_of_survey_question_uuids.includes(survey_question.survey_question_uuid)) {
                                    array_of_survey_questions.push(survey_question)
                                    array_of_survey_question_uuids.push(survey_question.survey_question_uuid)
                                }
                            }
                        }
                        /*
                        if(survey_question.script_uuid === this.active_conversation_script) {
                           // console.log(' array_of_survey_question_uuids ')
                           // JSON.stringify(array_of_survey_question_uuids)
                            
                            //pointless but why not i guess fo rdupes
                            if(!array_of_survey_question_uuids.includes(survey_question.survey_question_uuid)) {
                                array_of_survey_questions.push(survey_question)
                                array_of_survey_question_uuids.push(survey_question.survey_question_uuid)
                            }
                            
                        }
                        */
                        
                    });
                }
                return array_of_survey_questions
            }
          
        },
        methods: {
            
            
            set_active_tab_pane: function(tab_name) {
                this.active_tab_pane_name = tab_name
            },
            open_url_test: function() {
                return Front.openUrlInPopup('https://google.com',{height:900,width: 800,cancelToken:'stoprequestopen'})
            },
            close_survey_question_ui: function() {
                
                this.return_clear_survey_question_response()
                
            },
            pop_survey_question_ui: function(survey_question_uuid) {
                this.focused_survey_question_uuid = survey_question_uuid
                this.survey_question_reply_open = true

                this.$nextTick(function () {
                    this.rescroll_bottom()
                })
                
            },
            return_clear_survey_question_response: function() {
                this.focused_survey_question_uuid = null
                this.survey_question_reply_open = false
                this.draft_survey_question_answer_value = null
                this.is_saving_survey_question_data = false
                this.survey_question_response_from_quick_reply = false
            },
           
            reset_draft_sc_data: function() {
                this.is_saving_survey_question_data = false
                this.active_survey_question = {}
                this.draft_survey_question_answer_value = null
            },
           
            bind_message_textarea_focused: function() {
                this.is_send_textarea_focused = true
            },
            //TODO try to get below to work
            bind_message_textarea_unfocused: function() {
                this.is_send_textarea_focused = false
            },
            send_this_message: function() {
                //console.log('debug send_this_message')


                if(this.is_sending_message && this.is_sending_message === true) {
                    console.log('debug already sending a message')
                    setTimeout(() => {
                        this.is_sending_message = false
                    }, 1500);
                    return
                }

                if(this.draft_reply && this.draft_reply !== null && this.draft_reply !== '') {

                    this.is_sending_message = true

                    //double check...
                    if(this.$parent.contact_data.contact_lists_data.sent_to !== this.$parent.last_computed_sent_to_number) {
                         console.log('debug error mis matched sent_to?? mayhbe waiting for contact lists data sent_to stats?')
                    }

                    let use_this_messenging_service_sid = null

                    if(typeof this.$parent.contact_data.incoming_messages !== 'undefined' && this.$parent.contact_data.incoming_messages.length && this.$parent.contact_data.incoming_messages.length > 0) {
                        use_this_messenging_service_sid = this.$parent.contact_data.incoming_messages[0].messaging_service_sid
                    } else if(typeof this.$parent.active_messenger_service !== 'undefined' && this.$parent.active_messenger_service && typeof this.$parent.active_messenger_service.messaging_service_sid !== 'undefined' && this.$parent.active_messenger_service.messaging_service_sid !== null) {
                        use_this_messenging_service_sid = this.$parent.active_messenger_service.messaging_service_sid
                    } else {
                        console.log('error no messaging service to use?')
                        //clear it
                        //TODO clear into function no repeats
                        this.draft_reply = null
                        this.draft_sms_attachment = null
                        
                        this.is_sending_message = false
                        return swal.fire({
                            title: `Error sending message`,
                            text: 'Contact admin' ,
                            buttonsStyling: false,
                            icon: 'warning'
                        })
                    }

                    //TODO add another check based on the front current convo
                    //console.log(this.$parent.messenger_service_numbers_to_messenger_service_sid)
                    let this_account_sid = null
                    if(typeof this.$parent.message_services !== 'undefined' && this.$parent.message_services && this.$parent.message_services.length && this.$parent.message_services.length > 0) {
                        this.$parent.message_services.forEach((message_service,index) => {
                            if(message_service.messaging_service_sid === use_this_messenging_service_sid ) {
                                this_account_sid = message_service.account_sid
                            }
                        })
                    } else {
                        //clear it
                        //TODO clear into function no repeats
                        this.draft_reply = null
                        this.draft_sms_attachment = null
                        
                        this.is_sending_message = false
                        return swal.fire({
                            title: `Error sending message`,
                            text: 'Contact admin' ,
                            buttonsStyling: false,
                            icon: 'warning'
                        })
                    }
                    
                    console.log(this_account_sid)

                    if(this_account_sid === null) {
                        console.log('this_account_sid is null?')
                        //TODO clear into function no repeats
                        this.draft_reply = null
                        this.draft_sms_attachment = null
                        
                        this.is_sending_message = false
                        return swal.fire({
                            title: `Error sending message`,
                            text: 'Contact admin' ,
                            buttonsStyling: false,
                            icon: 'warning'
                        })
                    }

                    let this_message = {
                        org_id: this.$parent.active_org.org_id,
                        front_team_id: this.$parent.front_team_id,
                        user_uuid_created: this.$parent.active_user.user_uuid,
                        outbound_campaign_type: 'SMS',
                        contact_uuid: this.$parent.contact_data.contact_lists_data.contact_uuid,
                        account_sid: this_account_sid,
                        messaging_service_sid: use_this_messenging_service_sid,
                        sent_to: this.$parent.contact_data.contact_lists_data.sent_to,
                        body: this.draft_reply,
                        sms_attachment: null, //TODO would add image here if has
                        individual_message:true
                    }
              
                    if(this.draft_sms_attachment && this.draft_sms_attachment !== null) {
                        this_message.sms_attachment = this.draft_sms_attachment
                    }

                    console.log('debug going to send this message')
                    console.log(JSON.stringify(this_message))

                    //send it
                    
                    axios.post( 'https://'+this.$parent.use_this_api_domain+'/outbound_campaign/message',
                        this_message, {
                        headers: {
                        'Authorization': 'Bearer ' + this.$parent.active_user_jwt
                        }
                    })
                    .then((result,error) => {
                        if(result) {
                            console.log(result.data)
                        }
                        if(error) {
                            console.log(error)
                        }
                        
                        this_message.date_created = new Date().getTime()
                        this_message.direction = 'outbound'
                        this.$parent.contact_data.outbound_messages.push(this_message)
                        this.$parent.contact_data.merged_messages.push(this_message)

                        //clear it
                        this.draft_reply = null
                        this.draft_sms_attachment = null
                        
                        this.is_sending_message = false

                        //scroll
                        this.rescroll_bottom()

                        //if has sc data post that too
                        if(this.survey_question_response_from_quick_reply === true) {
                            console.log('time 851 send sc data too')
                            this.send_survey_question_data()
                            
                            //survey_question_response_from_quick_reply
                        }
      
                    })
                    
                                

                } else {
                    console.log('debug 732 shouldnt be here?')
                    this.draft_reply = null
                    this.draft_sms_attachment = null
                    this.return_clear_survey_question_response()

                }

                
                
                
            },
            send_survey_question_data: function(active_survey_question_uuid,passed_value) {
                if(typeof active_survey_question_uuid === 'undefined' || active_survey_question_uuid === null) {
                    active_survey_question_uuid = this.focused_survey_question_uuid
                }

                try {
                    if(this.is_saving_survey_question_data === true) {
                        console.log('debug already saving survey question data?')
                        //in case double clicks and just manually reset if api is slow
                        
                    } else {


                        if(this.$parent.has_contact_data && this.$parent.has_contact_data === false) {
                            console.log('debug no contact data in parent?')
                        }

                        if(this.$parent.is_processing_get_contact && this.$parent.is_processing_get_contact === true) {
                            console.log('debug is_processing_get_contact is true?')
                        }

                        this.is_saving_survey_question_data = true
                        let post_this_sc_data = {
                            survey_question_uuid: null,
                            script_uuid: null,
                            survey_question_answer_value:  null,
                            survey_question_data_type: null,
                            date_created: new Date().getTime(),
                            //gen on backend survey_question_answer_uuid: helpers.uuidv4(),
                            org_id: this.$parent.active_org.org_id,
                            front_team_id: this.$parent.front_team_id,
                            user_uuid_created: this.$parent.active_user.user_uuid,
                            sent_to: this.$parent.contact_data.contact_lists_data.sent_to || this.$parent.this_front_conversation_sent_to_number,
                            //TODO when pulling by only truncated sent_to there is no contact_uuid
                            contact_uuid: this.$parent.contact_data.contact_lists_data.contact_uuid || null
                        }

                        if(typeof active_survey_question_uuid === 'undefined' || active_survey_question_uuid === null) {
                            post_this_sc_data.survey_question_uuid = this.focused_survey_question_uuid
                        } else {
                            post_this_sc_data.survey_question_uuid = active_survey_question_uuid
                        }
                        
                        if(typeof passed_value === 'undefined' || passed_value === null) {
                            post_this_sc_data.survey_question_answer_value = this.draft_survey_question_answer_value || null  //.toString() below
                            //if(passed_value === null) {
                            //    //220603 doing this multiple places redundent clean me up
                            //    passed_value = 'FALSE'
                            //} else {
                            //    post_this_sc_data.survey_question_answer_value = passed_value //.toString() below
                            //}
                            
                        } else {     
                            //220603 default value?
                            post_this_sc_data.survey_question_answer_value = passed_value
                        }


                        if(!post_this_sc_data.survey_question_uuid || post_this_sc_data.survey_question_uuid === null ) {
                            console.log("error missing survey question id?")
                            swal.fire({
                                title: `Error saving data`,
                                text: 'Contact admin' ,
                                buttonsStyling: false,
                                icon: 'warning'
                            })
                            return this.return_clear_survey_question_response()
                        }

                        

                        //missing script_uuid
                        //survey questions have array now script_uuids[]
                        post_this_sc_data.script_uuid = this.active_conversation_script || null

                        if(post_this_sc_data.script_uuid === null) {
                            console.log('post_this_sc_data.script_uuid is null?')
                            swal.fire({
                                title: `Error saving data`,
                                text: 'Contact admin' ,
                                buttonsStyling: false,
                                icon: 'warning'
                            })
                            return this.return_clear_survey_question_response()
                        }

                        //find the data_type by uuid
                        this.$parent.survey_questions.forEach(survey_question => {
                            if(survey_question.survey_question_uuid === post_this_sc_data.survey_question_uuid) {
                                //console.log('debug matches survey_question_uuid ')
                                post_this_sc_data.survey_question_data_type = survey_question.survey_question_data_type
                                //double check current script is inside actual sc object
                                if(!survey_question.script_uuids.includes(post_this_sc_data.script_uuid)) {
                                    console.log('error this current script_uuid is not attached inside survey question in parent?')
                                }
                            }
                        });
                        




                        //TODO start here change the default based on post_this_sc_data.survey_question_data_type
                            //e.g. is boolean 'false' string 'false' int 0 ?
                            //should match spanner string, int64, float64, bool . what about array? or timestamp idk maybe useful for something like saving a lead time or something idk
                        try {
                            if(typeof post_this_sc_data.survey_question_data_type !== 'undefined') {
                                if(typeof post_this_sc_data.survey_question_data_type === 'bool' || (typeof  this.active_survey_question !== 'undefined' && typeof this.active_survey_question.input_type !== 'undefined' && this.active_survey_question.input_type === 'checkbox' ) ) {
                                    if(typeof post_this_sc_data.survey_question_answer_value === 'undefined' || post_this_sc_data.survey_question_answer_value === null ) {
                                        //default to FALSE
                                        post_this_sc_data.survey_question_answer_value = 'FALSE'
                                    }
                                }

                   
                            } else {
                                console.log('shuoldnt be here? post_this_sc_data.survey_question_data_type is undefined')
                                swal.fire({
                                    title: `Error saving data`,
                                    text: 'Contact admin' ,
                                    buttonsStyling: false,
                                    icon: 'warning'
                                })
                                return this.return_clear_survey_question_response()
                            }
                        } catch(e) {
                            console.log('debug 885 changing values so it posts as false bool')
                            console.log(e)
                            swal.fire({
                                title: `Error saving data`,
                                text: 'Contact admin' ,
                                buttonsStyling: false,
                                icon: 'warning'
                            })
                            return this.return_clear_survey_question_response()
                        }





                        //if(typeof post_this_sc_data.survey_question_answer_value === 'undefined' || post_this_sc_data.survey_question_answer_value === null) {
                        //    //220603 default to false
                        //    post_this_sc_data.survey_question_answer_value = 'FALSE'
                        //}

                        if(typeof post_this_sc_data.survey_question_answer_value !== 'undefined' && post_this_sc_data.survey_question_answer_value !== null) {
                            if(typeof post_this_sc_data.survey_question_answer_value !== 'string') {
                                console.log('post_this_sc_data.survey_question_answer_value is not string')
                                try {
                                    post_this_sc_data.survey_question_answer_value = post_this_sc_data.survey_question_answer_value.toString()
                                } catch(e) {
                                    console.log('error converting answer to string')
                                    console.log(e)
                                    swal.fire({
                                        title: `Error saving data`,
                                        text: 'Contact admin' ,
                                        buttonsStyling: false,
                                        icon: 'warning'
                                    })
                                    return this.return_clear_survey_question_response()
                                }
                               
                            }
                        } else {
                            console.log('still no post_this_sc_data.survey_question_answer_value value wtf...')
                            swal.fire({
                                title: `Error saving data`,
                                text: 'Contact admin' ,
                                buttonsStyling: false,
                                icon: 'warning'
                            })
                            return this.return_clear_survey_question_response()
                        }

                        console.log('post_this_sc_data')
                        console.log(JSON.stringify(post_this_sc_data))

                        //send it
                        axios.post( 'https://'+this.$parent.use_this_api_domain+'/survey_questions/answer',
                            post_this_sc_data, {
                            headers: {
                            'Authorization': 'Bearer ' + this.$parent.active_user_jwt
                            }
                        })
                        .then((result,error) => {
                            this.return_clear_survey_question_response()
                            if(result) {
                                console.log('saved survey question answer data')
                                console.log(result.data)
                                try {
                                    if(typeof this.$parent.contact_data !== 'undefined' && Array.isArray(this.$parent.contact_data.survey_question_answers) ) {
                                        this.$parent.contact_data.survey_question_answers.unshift(result.data)
                                    }
                                } catch(e) {
                                    console.log(e)
                                }
                            }
                            if(error) {
                                console.log(error)
                                swal.fire({
                                    title: `Error saving survey question data`,
                                    text:'Please contact admin',
                                    buttonsStyling: false,
                                    icon: 'warning'
                                })
                            }
                            
                        })
                        .catch((error) => {
                            console.log('save survey question error')
                            if(error) {
                                console.log(error)
                            }
                            swal.fire({
                                title: `Error saving survey question data`,
                                text:'Please contact admin',
                                buttonsStyling: false,
                                icon: 'warning'
                            })
                            return this.return_clear_survey_question_response()
                        })
        

                        //TODO ask front to add a notes/comments access point here

                    }
                } catch(e) {
                    console.log('error saving survey question data')
                    console.log(e)
                    return this.return_clear_survey_question_response()
                }

                
            
            },
            
            generate_quick_draft_reply: function(passed_quick_reply_uuid) {
                
                //??? close any open sc?

                if(this.survey_question_reply_open && this.survey_question_reply_open === true ) {
                    this.survey_question_reply_open = false
                    this.focused_survey_question_uuid = null
                }

                let this_quick_reply

               // console.log(passed_quick_reply_uuid)

                this.$parent.available_quick_replies.forEach(quick_reply => {
                    if(quick_reply.quick_reply_uuid === passed_quick_reply_uuid) {
                        this_quick_reply = quick_reply
                    }
                });

                let this_draft_reply_content = this_quick_reply.text_fallback


                //text_handlebars
                let create_data_object = {
                  active_user: this.$parent.active_user,
                  active_contact: this.$parent.contact_data.contact_lists_data
                }

                if(this_quick_reply.text_handlebars && this_quick_reply.text_handlebars !== null) {
                    //console.log(this_quick_reply.text_handlebars)
                    try {
                        this_draft_reply_content = generate_send_message.handlebars_bracket_replace(this_quick_reply.text_handlebars, create_data_object, this_quick_reply.reply_text_fallback)
                    } catch(e) {
                        console.log(e)
                    }
                }
              //  console.log(this_draft_reply_content)


                //console.log('debug this_draft_reply_content ' + this_draft_reply_content)
                this.draft_reply = this_draft_reply_content

                //if is attached to survey question set that draft data
                if(this_quick_reply.survey_question_affiliated && this_quick_reply.survey_question_affiliated === true) {
                    //survey_question_answer_value:true

                    //survey_question_uuid:"nskdfnksodnfoksmdf"
                    this.survey_question_response_from_quick_reply = true
                    this.focused_survey_question_uuid = this_quick_reply.survey_question_uuid
                    this.draft_survey_question_answer_value = this_quick_reply.survey_question_answer_value

                    
                    //survey_question_data_type
                }

                this.$nextTick(function () {
                    this.rescroll_bottom()
                })


            },
            call_this_contact: function(this_number) {
                console.log('debug call_this_contact function ' + this_number)

                if(this_number && this_number !== null) {
                    //TODO place a patch through call so it comes from our number
                    return swal.fire({
                        title: `Debug TODO`,
                        text: 'in future this will initiate a patch through call to ' + this_number ,
                        buttonsStyling: false,
                        icon: 'success'
                    })
                }
                
            }, 
            set_active_script: function(passed_script_uuid) {
                console.log('debug 907 set_active_script ' + passed_script_uuid)
                if(passed_script_uuid) {
                    this.available_scripts.forEach(script => {
                        if(script.script_uuid && script.script_uuid === passed_script_uuid) {
                            console.log('debug found match set active script object')
                            this.this_active_script = script
                            if(this.active_conversation_script !== script.script_uuid) {
                                this.active_conversation_script = script.script_uuid
                            }
                            
                        }
                    });
                }
                console.log('debug 920 call parent.set_available_quick_replies')
                this.$parent.set_available_quick_replies()
            },
            set_active_conversation_script: function(outbound_messages_array,script_uuid) {
                //console.log('debug 354 set active_conversation_script')
                //reset dr raft draft_survey_question_answer_value
                this.draft_survey_question_answer_value = null
                this.survey_question_reply_open = false

                let most_recent_outbound_message_script_uuid = null 
                if(script_uuid && script_uuid !== null && script_uuid !== '' ) {
                    most_recent_outbound_message_script_uuid = script_uuid
                    
                } else if(outbound_messages_array && outbound_messages_array.length && outbound_messages_array.length > 0 ) {
                    //reverse loop
                    
                    for (var i = outbound_messages_array.length - 1; i >= 0; i--) {
                        //console.log(outbound_messages_array[i].script_uuid);
                        if(outbound_messages_array[i].script_uuid && outbound_messages_array[i].script_uuid !== null && outbound_messages_array[i].script_uuid !=='') {
                            if(most_recent_outbound_message_script_uuid === null) {
                                most_recent_outbound_message_script_uuid = outbound_messages_array[i].script_uuid
                                break;
                            }
                        }
                    }
            
                } else {
                    console.log('debug no outbound messages or script uuid passed?')
                    most_recent_outbound_message_script_uuid = null
                }
                
                //console.log(most_recent_outbound_message_script_uuid)
                this.active_conversation_script = most_recent_outbound_message_script_uuid
                this.$parent.set_active_script(most_recent_outbound_message_script_uuid)
                this.$parent.set_available_quick_replies()
                this.rescroll_bottom()

            },
            rescroll_bottom: function() {
                //console.log('debug this.rescroll_bottom()')

                //make sure the data exists this_conversation_contact_last_incoming_message_uuid
                //220329
                //if( (this.this_conversation_contact_last_sent_campaign_message_uuid && this.this_conversation_contact_last_sent_campaign_message_uuid !== null ) || 
                //    ( this.this_conversation_contact_last_incoming_message_uuid && this.this_conversation_contact_last_incoming_message_uuid !== null ) 
                //)  
                //{
                    this.$nextTick(function () {
                        let the_div = document.getElementById("messages_container_scroll")
                        if(typeof  the_div !== 'undefined' && the_div !== null) {
                            the_div.scrollTo({
                                top: messages_container_scroll.scrollHeight - messages_container_scroll.clientHeight,
                                behavior: 'smooth'
                            });
                        } else {
                            setTimeout(() => {
                                if(typeof  the_div !== 'undefined' && the_div !== null) {
                                    the_div.scrollTo({
                                        top: messages_container_scroll.scrollHeight - messages_container_scroll.clientHeight,
                                        behavior: 'smooth'
                                    });
                                } else {
                                   // console.log('debug make a recursion function scroll too is fucked? do nothing')
                                }
                            }, 400);
                        }
                        
                    })
                //}
                


                //messages_container_scroll.scrollTop = messages_container_scroll.scrollHeight;
            },
            chicklet_parent: function(index) {
                try {
                    return 'this_add_chicklet_id_'+index
                } catch(e) {
                    console.log(e)
                }
            },
            chicklet_child_to_remove: function(index) {
                try {
                    return 'this_remove_chicklet_id_'+index
                } catch(e) {
                    console.log(e)
                }
            },
            unsub_this_contact: function(message_index) {
                
                //message_index is from merged_messages
                try {
                   if(this.$parent.contact_data && this.$parent.contact_data
                        && ( this.$parent.contact_data.contact_lists_data.sent_to || this.$parent.contact_data.contact_lists_data.contact_uuid )
                   ) {

                       //make a loading ux
                       if(document.getElementById('this_add_chicklet_id_'+message_index)) {
                           document.getElementById('this_add_chicklet_id_'+message_index).innerHTML = 
                           `<div class="tiny_load_svg" id="unsub_loading_small_`+message_index+`"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="L4" x="0px" y="0px" enable-background="new 0 0 0 0" xml:space="preserve" viewBox="0 44 52 12">
                                <circle fill="var(--blue)" stroke="none" cx="6" cy="50" r="6">
                                    <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.1"/>    
                                </circle>
                                <circle fill="var(--blue)" stroke="none" cx="26" cy="50" r="6">
                                    <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.2"/>       
                                </circle>
                                <circle fill="var(--blue)" stroke="none" cx="46" cy="50" r="6">
                                    <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.3"/>     
                                </circle>
                            </svg>`
                       }

                       let this_request_data = {}

                       if(this.$parent.contact_data.contact_lists_data.sent_to) {
                           this_request_data.sent_to = this.$parent.contact_data.contact_lists_data.sent_to
                       }
                       if(this.$parent.contact_data.contact_lists_data.contact_uuid) {
                           this_request_data.contact_uuid = this.$parent.contact_data.contact_lists_data.contact_uuid
                       }

                        //if has a message add it so can update twilio_logs. it also supports just basic unsub
                        if(message_index) {
                            console.log(message_index)

                            if(this.$parent.contact_data.merged_messages && this.$parent.contact_data.merged_messages.length && this.$parent.contact_data.merged_messages.length > 0) {

                                console.log('this incoming message clicked chicklet')
                                console.log(JSON.stringify(this.$parent.contact_data.merged_messages[message_index]))

                                if(this.$parent.active_org.org_id && this.$parent.contact_data.merged_messages[message_index].messaging_service_sid && this.$parent.contact_data.merged_messages[message_index].to && this.$parent.contact_data.merged_messages[message_index].message_sid) {
                                     this_request_data.org_id = this.$parent.active_org.org_id
                                    this_request_data.messaging_service_sid = this.$parent.contact_data.merged_messages[message_index].messaging_service_sid
                                    this_request_data.phone_number = this.$parent.contact_data.merged_messages[message_index].to
                                    this_request_data.message_sid = this.$parent.contact_data.merged_messages[message_index].message_sid
                                }
                               
                            }
                        }
                        

                        axios.post('https://'+this.$parent.use_this_api_domain+'/contact/subscription',this_request_data,
                        {
                            headers: {
                                'Authorization': 'Bearer ' + this.$parent.active_user_jwt
                            }
                        })
                        .then((result) => {
                            if(result) {
                                console.log(result)
                            }

                             //add a chicklet
                             if(document.getElementById('this_add_chicklet_id_'+message_index)) {

                                var unsub_badge = document.createElement("span");
                                unsub_badge.setAttribute('class','badge badge-danger')
                                unsub_badge.innerHTML = 'Unsubscribed'

                                document.getElementById('this_add_chicklet_id_'+message_index).appendChild(unsub_badge)
                                
                                if(document.getElementById('unsub_loading_small_'+message_index)) {
                                    document.getElementById('unsub_loading_small_'+message_index).remove()
                                }
                                if(document.getElementById('this_remove_chicklet_id_'+message_index)) {
                                    document.getElementById('this_remove_chicklet_id_'+message_index).remove()
                                }
                                
                             }

                            //yeah
                            /*
                            return  swal.fire({
                                title: `Unsubscribed this contact`,
                                text: null,
                                buttonsStyling: false,
                                icon: 'success'
                            })
                            */
                        })
                        .catch((error) => {
                            console.log(error)
                            return swal.fire({
                                title: `Error unsubscribing this contact`,
                                text: 'Contact admin support',
                                buttonsStyling: false,
                                icon: 'warning'
                            })
                            
                        })
                   }
                } catch(e) {
                    console.log(e)
                }
               
                
                //this.$parent.contact_data.contact_lists_data.sent_to,this.$parent.contact_data.contact_lists_data.contact_uuid
            }
        },
        mounted: function() {
            this.$nextTick(function () {
                console.log(this.$parent.contact_data || null)
                setTimeout(() => {
                    console.log(this.$parent.contact_data || null)
                },5000)
            })
            
            if(this.$parent.this_conversation_contact_last_sent_campaign_message && this.$parent.this_conversation_contact_last_sent_campaign_message.script_uuid !== null) {
                //change to parse loop array since outbound messages can be single no outbound campaign
                this.set_active_conversation_script(this.$parent.contact_data.outbound_messages, null)
            }
            
        

                /*
                try {
                    if(this.is_send_textarea_focused === true) {
                        console.log('is_send_textarea_focused = true')
                        if(event) {
                            if(event.keyCode) {
                                console.log(event.keyCode)
                                if (event.keyCode == 91 && event.keyCode == 13) {
                                    console.log('command enter')
                                    this.send_this_message()
                                }
                            }
                        }
                    }
                    
                    

                } catch(e) {
                    console.log(e)
                }
                */
            
            let recursive_load_message_scroll = (attempt_count,attempt_time) => {
                if(attempt_count < 4) {
                    attempt_count = attempt_count +1
                    this.$nextTick(function () {
                        setTimeout(() => {
                            try {
                                this.rescroll_bottom()
                            } catch(e) {
                                //console.log(e)
                                attempt_time = attempt_time*2
                                recursive_load_message_scroll(attempt_count,attempt_time)
                            }
                        }, attempt_time);
                        
                    })
                }
                
            }
            recursive_load_message_scroll(0,50)
            
        },
        watch: {
            focused_survey_question_uuid: {
                handler: function(newVal,oldVal) {
                    //console.log('debug new focused_survey_question_uuid ' + this.focused_survey_question_uuid)
                    let this_active_survey_question = {}
                    if(newVal && newVal !== null) {
                        
                        //search through available_survey_questions
                        this.available_survey_questions.forEach(available_survey_question => {
                            //console.log(available_survey_question.survey_question_uuid)
                            if(available_survey_question.survey_question_uuid === newVal) {
                                this_active_survey_question = available_survey_question
                            }
                        });
                    }
                    this.active_survey_question = this_active_survey_question
                }
            },
            this_conversation_contact_last_sent_campaign_message_uuid: {
                handler: function(newVal,oldVal) {
                   // console.log('debug this_conversation_contact_last_sent_campaign_message_uuid newVal ')
                   // console.log(JSON.stringify(newVal))
                   // console.log(JSON.stringify(oldVal))
                    if(newVal !== null) {
                        //change active script
                        if(this.$parent.contact_data && this.$parent.contact_data.outbound_messages && this.$parent.contact_data.outbound_messages.length && this.$parent.contact_data.outbound_messages.length > 0) {
                         //   console.log('debug 666 set new actie conversation script')
                            
                            this.set_active_conversation_script(this.$parent.contact_data.outbound_messages,null)
                        }
                    }
                }
            },
           
            draft_reply: {
                handler: function(newVal,oldVal) {
                    if(newVal && newVal !== null) {
                        if(newVal.length < 100 || newVal === null) {
                            document.getElementById('inline_draft_reply').classList.remove('long_reply_larger_box')
                            document.getElementById('inline_draft_reply').classList.remove('long_reply_larger_box_double')
                        } else if(newVal.length > 100 && newVal.length < 160) {
                            //console.log(('debug long reply make it bigger'))
                            document.getElementById('inline_draft_reply').classList.add('long_reply_larger_box')
                           
                        } else if(newVal.length > 160) {
                            document.getElementById('inline_draft_reply').classList.add('long_reply_larger_box_double')
                            if(newVal.length >= 280) {
                                this.draft_reply = this.draft_reply.substring(0,280)
                                swal.fire({
                                    title: `Message Draft Too Long`,
                                    text: 'Please write a smaller reply or send multiple messages.',
                                    buttonsStyling: false,
                                    icon: 'warning'
                                })
                            }
                        } else {
                            console.log("shouldnt be here debug too long message draft")
                            document.getElementById('inline_draft_reply').classList.remove('long_reply_larger_box_double')
                            document.getElementById('inline_draft_reply').classList.remove('long_reply_larger_box')
                        }
                    }
                }
            }
        }
    }

</script>
<style>
    .call_button_inline {
        vertical-align:text-bottom;
        margin-left: 10px;
        font-size:18px !important;
    }
    .contact_heading h1, .contact_heading span {
        display: inline-block;
        font-size: 32px;
        margin-bottom: 3px;
        vertical-align: middle !important;
    }
    .summery_item_col p {
        font-size:12px;
        margin-bottom:2px;
    }  
    .summery_item_col h3 {
        margin-top:0px;
        font-size: 38px;
    }
    .summery_item_col h4 {
        font-weight:normal;
    }
    .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
        background: #fff;
        color:#007aff;
    }
    .survey_questions_accordian .card {
        border: 1px solid rgba(0,0,0,.3);
    }
    .survey_questions_accordian .accordion > .card:first-of-type {
        border-bottom: 1px solid rgba(0,0,0,.3) !important;
    }
    .survey_questions_accordian .collapsed {
         background: rgba(0,0,0,.03);
    }
    .survey_questions_accordian .not-collapsed {
         background: var(--bg-white);
  
    }

    .survey_questions_header {
        text-align:left;
        font-size: 24px;
        font-weight: 600;

    }
    .survey_questions_header span {
        display:inline-block;
        font-size: 30px;
        vertical-align:sub;
    }
    .script_preview_contain_top, .script_preview_contain_bottom {
       max-width:500px; 
       margin:0 auto;
       border: 1px solid rgba(0,0,0,.3);
       padding: 10px;

    }
    .script_preview_contain_bottom {
        padding:10px 0px;
    }
    .script_preview_contain_top {
        border-radius: 8px 8px 0 0;
        box-sizing:border-box;
        overflow-x: hidden;
        overflow-y: auto;
        height:250px;
        display: flex;
        flex-direction: column;
    }

    .script_preview_contain_bottom {
        border-radius: 0px 0px 8px 8px;
        min-height:40px;
    }
    .script_preview_contain_top .row {
        flex-wrap: nowrap;
        margin-right: 15px;
        margin-left: 15px;
        align-content: center;
        justify-content: center;
        flex-direction: column;
    }

   .script_preview_contain {
       max-width:500px;
       border-radius: 5px;
       margin:0 auto;
       border: 1px solid rgba(0,0,0,.3);
       padding: 10px;
   }
   .script_preview_contain p {
       font-size: 12px;
       text-align:center;
       margin-bottom: 5px;
   }

    .messages {
        font-size:12px;
    margin-top: 5px;
    display: flex;
    flex-direction: column;
    }

    .message {
    border-radius: 20px;
    padding: 8px 15px;
    margin-top: 5px;
    margin-bottom: 5px;
    display: inline-block;
    }

    .yours {
    align-items: flex-start;
    }

    .yours .message {
    margin-right: 25%;
    background-color: #EEE;
    position: relative;
    }

    .yours .message.last:before {
    content: "";
    position: absolute;
    z-index: 0;
    bottom: 0;
    left: -7px;
    height: 20px;
    width: 20px;
    background: #EEE;
    border-bottom-right-radius: 15px;
    }
    .yours .message.last:after {
    content: "";
    position: absolute;
    z-index: 1;
    bottom: 0;
    left: -10px;
    width: 10px;
    height: 20px;
    background: white;
    border-bottom-right-radius: 10px;
    }

    .mine {
    align-items: flex-end;
    }

    .mine .message {
    color: white;
    margin-left: 25%;
    background: rgb(0, 120, 254);
    position: relative;
    }

    .mine .message.last:before {
    content: "";
    position: absolute;
    z-index: 0;
    bottom: 0;
    right: -8px;
    height: 20px;
    width: 20px;
    background: rgb(0, 120, 254);
    border-bottom-left-radius: 15px;
    }

    .mine .message.last:after {
    content: "";
    position: absolute;
    z-index: 1;
    bottom: 0;
    right: -10px;
    width: 10px;
    height: 20px;
    background: white;
    border-bottom-left-radius: 10px;
    }
    .full-width {
        width: 100% !important;
    }
    .answer_input_contain {
        margin-bottom: 8px;
    }
    .answer_input_contain .form-group {
        margin: 0px;
    }
    
    .card-header {
        border-bottom: 0px !important;
    }
    .preview_info_text {
        font-size: 14px;
        margin:0px;
        text-align:center;
        margin:0 auto;
        font-style:italic;
    }
    .text_message_small_text {
        font-size: 12px;
        font-style:italic;
    }

    .script_message_button {

        padding-top:5px;
        padding-bottom:22px;
        text-align:center;
    }
    .script_message_button .btn-default {
        background: #fff;
        color: var(--gray-600);
        border: 1px solid var(--gray-300);
    }




input[type=range] {
    width: 100%;
}
.styled_range_input_contain {
    padding:0px 20px 0px 20px;
}



.gradient-range {
  width: 100%;
  height: 16px;
  background: linear-gradient(45deg, #ff3b30 10%, #602697 50%, #3399ff 90%);
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  outline: none;
  border-radius:8px;
}
.gradient-range::-webkit-slider-thumb {
  width: 2em;
  height: 2em;
  background: var(--white);
  border: 2px solid var(--blue);
  border-radius: 50%;
  -webkit-appearance: none;
          appearance: none;
  cursor: -webkit-grab;
  cursor: grab;
  -webkit-transition: border 1s;
  transition: border 1s;
}
.gradient-range::-webkit-slider-thumb:active {
  cursor: -webkit-grabbing;
  cursor: grabbing;
}
.gradient-range.green::-webkit-slider-thumb {
  border-color: #70c1b3;
}
.gradient-range.blue::-webkit-slider-thumb {
  border-color: #247ba0;
}
.gradient-range.yellow::-webkit-slider-thumb {
  border-color: #f3ffbd;
}
.gradient-range.crimson::-webkit-slider-thumb {
  border-color: #ff1654;
}








.survey_question_range_contain, .survey_question_dropdown_contain, .survey_question_checkbox_contain {
    margin-bottom: 10px;
    text-align:center;
}
.survey_question_checkbox_contain .custom-control {
    margin-top: 6px;
    padding-left: 17px;
}
.survey_question_range_contain p {
    margin:0px;
}
.survey_question_range_contain input[type=range] {
    margin-top: 5px;
}

.range_label_left {
    float:left;

    width: 30%;
    margin-right: 10%;
    text-align:left;
}
.range_label_left p, .range_label_right p {
    font-weight: bold;
    margin:0px;
    color: var(--gray-600);
}
.range_label_center {
    margin: 0 auto;
    text-align:center;
}
.range_label_center p {
    border-radius: 10px;
    background: var(--gray-100);
    width: 50px;
    margin: 0 auto;
}
.range_label_right {
    float:right;
    width: 30%;
    margin-left: 10%;
    text-align:right;
}


.survey_questions_accordian .card-body {
    padding-top:0px;
}

.quick_replies_contain ul {
    list-style:none;
    display:flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    margin:0 auto;
    margin-top: 15px;
    padding-left:0px;
}
.quick_reply_button {
    border: 1px solid var(--blue);
    border-radius: 16px;
    margin-right: 20px;
    cursor:pointer;
    padding: 6px 10px;
    font-size:12px;
    line-height:12px;
    text-align:center;
    color:var(--blue);
}
.quick_reply_button:hover {
    color:var(--blue-darker);
    border-color:var(--blue-darker);
    -webkit-box-shadow: 0 4px 6px rgb(50 50 93 / 11%), 0 1px 3px rgb(0 0 0 / 8%);
    box-shadow: 0 4px 6px rgb(50 50 93 / 11%), 0 1px 3px rgb(0 0 0 / 8%);
}
.quick_replies_contain p {
    font-size: 12px;
    text-align:center;
    color:var(--gray-400);
}
.reply_contain_flex {
   display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -ms-flex-direction: row;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    flex-direction: row;
    -ms-flex-wrap: nowrap;
    flex-wrap: wrap;
    -ms-flex-pack: center;
    -webkit-box-pack: center; 
    justify-content: space-around;
    -ms-flex-line-pack: center;
    align-content: center;
    -ms-flex-align: center;
    -webkit-box-align: center; 
    align-items: center;
}
.reply_box_left .btn {
    vertical-align:text-top;
    margin-top:1px;
    font-size:12px;
    font-weight:400;
    padding:4px 8px;
}
.send_area_icon .material-icons:hover {
    color:var(--blue-darker);
}

.reply_box_left .btn:hover  {
    transform:none;
    background:var(--blue-darker);
}
.reply_box_left .material-icons {
    margin-top: -1px;
}
.float_left {
    float:left;
}
.reply_box_right {
    text-align:right;
    vertical-align:middle;
    line-height:36px;
}

.reply_box_middle .form-group {
    margin:0;
}
.reply_box_middle textarea.form-control {
    resize:none;
    width:100%;
    border-radius:18px;
    height:46px;
    min-width:320px;
    line-height:18px;
    font-size:12px;
    vertical-align:middle;
    padding:4px 12px 4px 12px;
}
.reply_box_middle textarea.long_reply_larger_box {
    height:68px !important;

}
.reply_box_middle textarea.long_reply_larger_box_double {
    height: 100px !important;
}
.send_area_emoji_icon {
    position:absolute;
    right:18px;
    top:2px;
    display:none; /*for now hide not done*/
}

.send_area_icon .material-icons {
    font-size:32px;
    top:2px;
}
.blue_border_top {
border-top: 1px solid var(--blue);
}
.quick_survey_question_contain {
    
    padding: 2px 8px 8px 8px;
    margin-top: 10px;
}
.sc_top_info {
    font-size:12px;
    text-align:center;
    margin:0px;
    padding:0 ;

}
.sc_button_center {
    margin: 0 auto;
    text-align:center
}
.inline_sc_buttons, .survey_question_dropdown_contain {
    margin: 0 auto;
    text-align:center
}
.survey_question_dropdown_contain .dropdown, .inline_sc_buttons .btn {
    margin-right: 20px;
}

.typing_svg svg, .sending_message_dots_centered svg {
    width: 32px;
}
.tiny_load_svg, .tiny_load_svg svg {
    width: 20px;
}
.sending_message_dots_centered {
    margin: 0 auto;
    text-align:center;
}

.message_image {
    max-width: 150px;
    margin-bottom: 10px;
}
.message_image img {
    width: 100%;
    display: inline-block;
}
.summary_item_contain {
    margin-bottom: 20px;
}
.sc_script_name {
    font-size: 12px;
    vertical-align:top;
    text-align:right
}
.sc_script_name .material-icons.md-18 {
    vertical-align:top;
}
.sc_group_list {
    border: 1px solid var(--gray-600);
    border-radius: 10px;
}
.sc_group_list .sc_item:not(:last-child) {
    border-bottom: 1px solid var(--gray-400);
}
.sc_item {
    padding: 10px;
}
.sc_item:hover {
    background: var(--gray-100);
    border-radius: 10px;
}


    @media (max-width: 520px) {
        .mini_text_small_screen {
            font-size: 12px !important;
        }
    }
</style>
